export const womenLevelTwo = [
    {
      name: "Active Wear",
      categoryId: "women_active_wear",
      parentCategoryId: "women",
      level: 2,
    },
    {
      name: "Sleep Wear",
      categoryId: "women_sleep_wear",
      parentCategoryId: "women",
      level: 2,
    },
    {
      name: "Western Wear",
      categoryId: "women_western_wear",
      parentCategoryId: "women",
      level: 2,
    },
    {
      name: "Footwear",
      categoryId: "women_footwear",
      parentCategoryId: "women",
      level: 2,
    },
    {
      name: "Accessories",
      categoryId: "women_accessories",
      parentCategoryId: "women",
      level: 2,
    },
    {
      name: "Top Wear",
      categoryId: "women_topwear",
      parentCategoryId: "women",
      level: 2,
    },
   
  ];
  